import { useState, useEffect } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";

const REPORT_FIELDS = [
  { key: "client_first_name", label: "Client First Name" },
  { key: "client_last_name", label: "Client Last Name" },
  { key: "client_birthday", label: "Client Birthday" },
  { key: "client_age", label: "Client Age" },
  { key: "case_type_category", label: "Case Type Category" },
  { key: "case_type", label: "Case Type" },
  { key: "incident_date", label: "Incident Date" },
  { key: "intake_date", label: "Intake Date" },
  { key: "retained_date", label: "Retained Date" },
  { key: "acceptance_date", label: "Acceptance Date" },
  { key: "closed_date", label: "Closed Date" },
  { key: "referred_date", label: "Referred Date" },
  { key: "rejected_date", label: "Rejected Date" },
  { key: "source_type", label: "Source Type" },
  { key: "source_name", label: "Source Name" },
  { key: "secondary_source_type", label: "Secondary Source Type" },
  { key: "secondary_source_name", label: "Secondary Source Name" },
  { key: "third_source_type", label: "Third Source Type" },
  { key: "third_source_name", label: "Third Source Name" },
  { key: "firm_user_intake", label: "Firm User who did Intake" },
  { key: "firm_user_retained", label: "Firm User who Retained" },
  { key: "firm_user_accepted", label: "Firm User who Accepted" },
  { key: "firm_user_rejected", label: "Firm User who Rejected" },
  { key: "firm_user_referred", label: "Firm User who Referred" },
];

const ReportValueModal = ({ show, handleClose, currentValues, onSave }) => {
  const [form, setForm] = useState({
    client_first_name: false,
    client_last_name: false,
    client_birthday: false,
    client_age: false,
    case_type_category: false,
    case_type: false,
    incident_date: false,
    intake_date: false,
    retained_date: false,
    acceptance_date: false,
    closed_date: false,
    referred_date: false,
    rejected_date: false,
    source_type: false,
    source_name: false,
    secondary_source_type: false,
    secondary_source_name: false,
    third_source_type: false,
    third_source_name: false,
    firm_user_intake: false,
    firm_user_retained: false,
    firm_user_accepted: false,
    firm_user_rejected: false,
    firm_user_referred: false,
  });

  useEffect(() => {
    if (currentValues) {
      setForm(currentValues);
    }
  }, [currentValues, show]);

  const toggleField = (fieldKey) => {
    setForm((f) => ({ ...f, [fieldKey]: !f[fieldKey] }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    REPORT_FIELDS.forEach((field) => {
      allSelected[field.key] = true;
    });
    setForm(allSelected);
  };

  const handleClearAll = () => {
    const allCleared = {};
    REPORT_FIELDS.forEach((field) => {
      allCleared[field.key] = false;
    });
    setForm(allCleared);
  };

  const handleApply = () => {
    onSave(form);
  };

  const selectedCount = Object.values(form).filter(Boolean).length;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <div style={{ minHeight: "200px" }}>
        <Modal.Header
          style={{
            borderBottom: "0px",
          }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Report Values - Intake Fields ({selectedCount} selected)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5" style={{ minHeight: "max-content" }}>
          <div className="custom-tab">
            {/* Fields List - 2 columns */}
            <Row className="mx-0 pe-0">
              <Col md={12} className="p-0">
                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  <div className="d-flex flex-wrap mx-0 pe-0">
                    {REPORT_FIELDS.map((field) => (
                      <div
                        key={field.key}
                        className="col-md-6 p-l-0"
                        style={{
                          paddingRight: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        <label
                          className="d-flex align-items-center"
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600",
                            margin: 0,
                            padding: "0px 5px",
                            background: form[field.key] ? "var(--primary-10)" : "transparent",
                            borderRadius: "4px",
                            transition: "all 0.15s",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={form[field.key]}
                            onChange={() => toggleField(field.key)}
                            style={{
                              marginRight: "5px",
                              width: "13px",
                              height: "13px",
                              cursor: "pointer",
                            }}
                          />
                          {field.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <div
            className="d-flex align-items-center "
            style={{
              gap: "5px",
            }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
              variant="primary"
              onClick={handleClearAll}
            >
              Clear All
            </Button>
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
              variant="primary"
              onClick={handleSelectAll}
            >
              Select All
            </Button>
          </div>
          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            onClick={handleApply}
          >
            Apply Selection
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default ReportValueModal;
